import { combineReducers } from "redux";
import user from "./userReducer";
import gallery from "./galleryReducer";
import mapinfo from "./mapReducer";
import { ORM_LIST_KEY, ORM_OBJECT_KEY } from '../orm/keys'
import orm_list_reducer from '../orm/orm_list_reducer'
import orm_general_reducer from '../orm/orm_general_reducer'
import orm_objects_reducer from '../orm/orm_objects_reducer'
import auth from './auth'
import ui from './ui'

const appReducer = combineReducers({
    [ORM_OBJECT_KEY]: orm_objects_reducer,
    [ORM_LIST_KEY]: orm_list_reducer,
    orm_general_reducer,
    auth,
    user,
    gallery,
    mapinfo,
    ui
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
